import { Injectable } from '@angular/core';
import { Paginator, SortDirection } from '@app/classes';
import { ApplicantAttachment } from '@app/models/recruiting/applicant-attachments.model';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { DateUploadedColumn, NameColumn, UploadedByColumn } from './columns';

@Injectable()
export class ApplicantDocumentsIndexTable extends Table<ApplicantAttachment> {
    static editOption: MenuColumnItem = {
        label: 'edit',
        event: 'edit',
    };

    static downloadOption: MenuColumnItem = {
        label: 'download',
        event: 'download',
    };

    static deleteOption: MenuColumnItem = {
        label: 'delete',
        event: 'delete',
    };

    showMenuColumnOptions = true;
    defaultSortProperty = 'jobAttachmentIdAndCreatedAt';
    sortDirection: SortDirection = SortDirection.DESC;

    constructor(private applicant: Applicant) {
        super();
        this.paginator = null;

        this.setDataSource();
        this.setColumns();
        this.setColumnWidths();
        this.paginator.onLoading((loading) => {
            this.onLoading.next(loading);
        });
        this.subscribeToAllFilters();
        this.paginator.setSort({
            column: this.defaultSortProperty,
            order: this.sortDirection,
        });
    }

    async reload(): Promise<void> {
        await this.paginator.loadData();
    }

    setColumns(): void {
        this.addColumns(new NameColumn(), new DateUploadedColumn(), new UploadedByColumn());
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        return [
            ApplicantDocumentsIndexTable.downloadOption,
            ApplicantDocumentsIndexTable.editOption,
            ApplicantDocumentsIndexTable.deleteOption,
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            ApplicantAttachment.where('applicantId', this.applicant.id)
                .where('onlyDocuments', true)
                .with(['jobAttachment', 'file.uploadedBy'])
        );
    }
}
